import ProductSwiper from "components/commonComponent/productSwiper";
import useTenFreeDeliveryProducts from "hook/useTenFreeDeliveryProducts";
import newIcon from "images/freeDelivery.png";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
const FreeDeliveryProducts = () => {
  const { tenFreeDeliveryProducts, loading1 } = useTenFreeDeliveryProducts();
  const { language } = useSettings();
  return (
    <div>
      <ProductSwiper
        data={tenFreeDeliveryProducts}
        loading={loading1}
        link="/freeDeliveryProducts"
        title={t("freeShipping", language)}
        icon=""
      />
    </div>
  );
};

export default FreeDeliveryProducts;
